import React from "react";
import { DynamicMultiSelectDropdown } from "src/Components";
import {
  getPortfolioGroupAccountsDropdown,
  getPortfolioGroupDropDown,
} from "src/Requests/portfolioGroups";

interface Props {
  portfoGroupIds: number[];
  accountIds: number[];
  onChange: (name: "portfoGroupIds" | "accountIds", value: string[]) => void;
}

const PortfolioFilterMultiSelects: React.FC<Props> = ({
  portfoGroupIds,
  accountIds,
  onChange,
}) => (
  <>
    <div className="w-[220px]">
      <DynamicMultiSelectDropdown
        dropdown={{
          name: "portfoGroupIds",
          placeholder: "گروه پرتفو",
          extraLabel: true,
        }}
        getData={getPortfolioGroupDropDown}
        onChange={(name, value) =>
          onChange(name as "portfoGroupIds", value)
        }
        value={portfoGroupIds}
        withSelectAll
      />
    </div>
    <div className="w-[220px]">
      <DynamicMultiSelectDropdown
        dropdown={{
          name: "accountIds",
          placeholder: "اکانت",
          extraLabel: true,
        }}
        getData={getPortfolioGroupAccountsDropdown}
        onChange={(name, value) => onChange(name as "accountIds", value)}
        value={accountIds}
        withSelectAll
      />
    </div>
  </>
);

export default PortfolioFilterMultiSelects;
